import { apiFetch, apiStream } from "../../../services/apiClient";

const fieldMapping = {
  studyName: "name",
  problemDefinition: "initial_input",
  methodologies: "methodologies",
  targetAudience: "target_audience",
  participantCount: "participant_count",
  startDate: "start_date",
  endDate: "end_date",
  timeline: "timeline",
  budget: "budget",
  additionalRequirements: "additional_requirements",
};

export const mapStudyToFormData = (studyData = {}) => ({
  studyName: studyData.name || "",
  problemDefinition: studyData.initial_input || "",
  methodologies: studyData.methodologies || [],
  timeline: studyData.timeline || "",
  startDate: studyData.start_date || "",
  endDate: studyData.end_date || "",
  budget: studyData.budget || "",
  targetAudience: studyData.target_audience || "",
  participantCount:
    studyData.participant_count != null ? String(studyData.participant_count) : "",
  additionalRequirements: studyData.additional_requirements || "",
});

export const buildStudyUpdatePayload = (formData, study) => {
  const updateData = {};

  for (const [frontendField, backendField] of Object.entries(fieldMapping)) {
    let value = formData[frontendField];

    if (value === undefined || value === null || value === "") {
      const studyField = fieldMapping[frontendField];
      if (studyField && study?.[studyField] !== undefined) {
        value = study[studyField];
      }
    }

    if (frontendField === "participantCount") {
      value = value && value !== "" ? parseInt(value, 10) : null;
    } else if (frontendField === "startDate" || frontendField === "endDate") {
      value = value && value !== "" ? value : null;
    } else if (frontendField === "methodologies") {
      value = Array.isArray(value) ? value : value || [];
    }

    if (value !== undefined) {
      updateData[backendField] = value;
    }
  }

  return updateData;
};

export const getProjectBySlug = async (projectSlug) => {
  const response = await apiFetch(`/projects/by-slug/${projectSlug}`, { method: "GET" });
  return response.ok ? response.json() : null;
};

export const getStudyBySlug = async (studySlug) => {
  const response = await apiFetch(`/studies/by-slug/${studySlug}`, { method: "GET" });
  return response.ok ? response.json() : null;
};

export const getStudyById = async (studyId) => {
  const response = await apiFetch(`/studies/${studyId}`, { method: "GET" });
  return response.ok ? response.json() : null;
};

export const updateStudy = async (studyId, updateData) => {
  const response = await apiFetch(`/studies/${studyId}`, {
    method: "PUT",
    body: JSON.stringify(updateData),
  });

  if (!response.ok) {
    const errorText = await response.text();
    const error = new Error(errorText);
    error.response = response;
    throw error;
  }

  return response;
};

export const regenerateStudyPlan = async (studyId, payload) => {
  const response = await apiFetch(`/studies/${studyId}/regenerate-plan`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return response.json();
};

export const streamStudyHelperChat = (payload) =>
  apiStream("/study-helper/chat", {
    method: "POST",
    body: JSON.stringify(payload),
  });
